import { Inject, Injectable } from "@angular/core";
import { TEMPLATE_SERVICE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { TemplateByKeywordInfo, TemplatesByKeyword } from "./templates-pon-list.models";

/**
 * Serviço auxiliar para montagem do dados dos templates PON
 * para visualização agrupada por keywords.
 */
@Injectable({
    providedIn: "root"
})
export class TemplatesPonListService {

    readonly ponKeywords = ["PON"];

    constructor(@Inject(TEMPLATE_SERVICE) private readonly templateService) { }

    async getTemplatesByKeywords(): Promise<TemplatesByKeyword[]> {
        const keywordsTemplates: TemplatesByKeyword[] = [];

        const promises = this.ponKeywords.map(word => this.templateService.getTemplatesByKeywords(word));
        const templatesResponse = await Promise.all(promises);

        let templates = templatesResponse.flatMap(templateResponse => templateResponse.plain());

        this.removeTemplatesWithManualApplication(templates);
        templates = this.handleKeywords(templates);

        templates.forEach((keywordTemplates) => {
            const templatesInfo = keywordTemplates.templatesIdentifiers.map((templateIdentifier) => {
                return {
                    label: templateIdentifier.templateName,
                    description: templateIdentifier.templateDescription,
                    templateId: templateIdentifier.templateId
                };
            });

            keywordsTemplates.push({
                keyword: keywordTemplates.keyword,
                templatesIdentifiers: templatesInfo
            });
        });

        return keywordsTemplates;
    }

    private handleKeywords(keywordsTemplatesRequest) {
        const keywordsTemplatesResponse: TemplatesByKeyword[] = [];
        const replaceKeyword = (keyword) => keyword.replace(/GPON|XGSPON/ig, "PON");

        new Set(keywordsTemplatesRequest.map(keywordTemplate => replaceKeyword(keywordTemplate.keyword)))
            .forEach((keyword: string) => {
                const templatesByKeyword =
                    keywordsTemplatesRequest.filter(keywordTemplate => replaceKeyword(keywordTemplate.keyword) === keyword);
                const templatesIdentifiers = templatesByKeyword
                    .flatMap(keywordTemplate => keywordTemplate.templatesIdentifiers);

                const templatesByTemplateId = templatesIdentifiers.map(item => [item["templateId"], item]);

                const uniqueTemplates = [...new Map(templatesByTemplateId).values()] as TemplateByKeywordInfo[];

                keywordsTemplatesResponse.push({
                    keyword,
                    templatesIdentifiers: uniqueTemplates
                });
            });

        return keywordsTemplatesResponse;
    }

    private removeTemplatesWithManualApplication(templates: TemplatesByKeyword[]) {
        templates.forEach((template) => {
            const nonApplicationNameManualTemplates = template.templatesIdentifiers.filter((identifier) => {
                return !identifier.applicationNameManual;
            })

            template.templatesIdentifiers = nonApplicationNameManualTemplates;
        });
    }
}
